<script>

/**
 * Form elements component
 */
export default {
  components: {

  },
  props: {
    selected: {
      type: Number,
      required: true,
      default: 1,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {

  }
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-center">
      <div v-if="selected === 0">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/y3y7Dw1LeBw" title="Promoción y Prevención."
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 1">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/WObAJXqKgj8"
          title="¿Qué es riesgo Biológico? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 2">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/IlSlsUiLYVc"
          title="¿Qué es riesgo físico? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 3">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/AgL05yi-3ZQ"
          title="¿Qué es Riesgo Químico? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 4">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/KsawTwkefgI"
          title="¿Qué es Riesgo Psicosocial? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 5">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/ApzYwN3dCmc"
          title="¿Qué es Riesgo Ergonómico? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 6">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/swKTS0uQ_D8"
          title="¿Qué es Riesgo Mecánico? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
      <div v-if="selected === 7">
        <iframe width="734" height="413" src="https://www.youtube.com/embed/6VJnnUHfNmw"
          title="¿Qué es Riesgo Ambiental? SST" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>
